import React from 'react';
import {
  DataGridPro,
  DataGridProProps,
  GridColDef,
  GridRowsProp,
} from '@mui/x-data-grid-pro';
import { StyledDataGrid } from './DataGrid.style';

export interface DataGridProps extends Omit<DataGridProProps, 'rows' | 'columns'> {
  /**
   * The data rows
   */
  rows: GridRowsProp;
  /**
   * The column definitions
   */
  columns: GridColDef[];
  /**
   * Whether to show loading state
   */
  loading?: boolean;
  /**
   * Height of the DataGrid
   */
  height?: number | string;
  /**
   * Whether to enable row selection
   */
  checkboxSelection?: boolean;
  /**
   * Whether to disable column menu
   */
  disableColumnMenu?: boolean;
  /**
   * Whether to disable column filter
   */
  disableColumnFilter?: boolean;
}

export const DataGrid: React.FC<DataGridProps> = ({
  rows,
  columns,
  loading = false,
  height = 400,
  checkboxSelection = false,
  disableColumnMenu = false,
  disableColumnFilter = false,
  ...props
}) => {
  return (
    <StyledDataGrid
      style={{ height }}
      rows={rows}
      columns={columns}
      loading={loading}
      checkboxSelection={checkboxSelection}
      disableColumnMenu={disableColumnMenu}
      disableColumnFilter={disableColumnFilter}
      rowsPerPageOptions={[5, 10, 25, 50, 100]}
      pageSize={10}
      pagination
      {...props}
    />
  );
}; 